import { SubscriptionFormData } from 'features/checkout/state/types';

export const initialFormData: SubscriptionFormData = {
  cardCVV: '',
  cardExpirationDate: '',
  cardNumber: '',
  cardOwnerName: '',
  cpfCnpj: '',
  turnstileToken: '',
};
